export default __webpack_public_path__ + "static/media/TrustDeed1.e6787abf.jpeg";